import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Row, Col, Card, Slider, Button, Icon} from 'antd';

import * as mapActions from '../actions/map-actions';
import HeatMap from '../charts/HeatMap';
import LineChart from '../charts/LineChart';
import HeatBarChart from '../charts/HeatBarChart';
import ReadMore from '../components/ReadMore.js';
import CardMenu from './CardMenu.js';

import './OverdoseCard.css';

class OverdoseCard extends Component {

  constructor(props) {
    super(props);

    this.state = {
      playing: false,
      sliderYear: 2015,
      year: 2015
    }
  }

  onAfterChange(value) {
    this.stop();
    this.setState({year: value, sliderYear: value});
  }

  componentWillUnmount() {
    this.stop();
  }

  backClick() {
    this.stop();

    let newYear = this.state.year - 1;
    if (newYear < 2000) {
      newYear = 2015;
    }
    this.setState({year: newYear, sliderYear: newYear});
  }

  forwardClick() {
    this.stop();

    let newYear = this.state.year + 1;
    if (newYear > 2015) {
      newYear = 2000;
    }
    this.setState({year: newYear, sliderYear: newYear});
  }

  playClick() {
    this.state.playing ? this.stop() : this.play();
  }

  play() {
    this.setState({year: 2000, sliderYear: 2000, playing: true});
    this.timer = setInterval(this.tick.bind(this), 800);
  }

  stop() {
    this.setState({playing: false});
    clearInterval(this.timer);
  }

  tick() {
    let newYear = this.state.year + 1;

    if (newYear > 2015) {
      this.stop();
    }
    else {
      this.setState({year: newYear, sliderYear: newYear});
    }
  }

  render() {

    const marks = {
      2000: '2000',
      2001: '2001',
      2002: '2002',
      2003: '2003',
      2004: '2004',
      2005: '2005',
      2006: '2006',
      2007: '2007',
      2008: '2008',
      2009: '2009',
      2010: '2010',
      2011: '2011',
      2012: '2012',
      2013: '2013',
      2014: '2014',
      2015: '2015'
    };

    const playBtn = (
      <Button.Group type="primary" size="small" style={{marginTop: '-4px'}}>
        <Button onClick={this.backClick.bind(this)}>
          <Icon type="step-backward"/>
        </Button>
        <Button onClick={this.forwardClick.bind(this)}>
          <Icon type="step-forward"/>
        </Button>
        <Button onClick={this.playClick.bind(this)}>
          <Icon type={this.state.playing ? 'pause' : 'caret-right'} style={{color: '#c85a5a'}}/>
        </Button>
      </Button.Group>
    );

    const title = (
      <CardMenu showLocations={true} title={
        <span><span className="hidden-sm-down">National </span>Overdose Statistics</span>
      }/>
    );

    return (
      <Card className="OverdoseCard" title={title} extra={playBtn} noHovering={true}>
        <Row gutter={35}>
          <Col xs={24} md={6} xl={5}>
            <p>
              <b>Understanding the Problem:</b><br/>
              Responsible for over 33,000 American deaths in 2015 alone, the American Opioid Epidemic is the first
              epidemic rooted in modern medicine - the misuse and abuse of prescription opioids.
            </p>

            <p className="lead">
              These visualizations show the age adjusted drug overdose death rates at the county level, as
              compared to the state and national levels over time.</p>

            <ReadMore>
              <p>The national heatmap shows the age adjusted drug overdose death rates for the
                selected year and colors each county across a percentile scale of that years values.
                Darker colors indicate a higher death rate and lighter colors a lower death rate.
                The number of counties falling within each death rate is displayed in
                the bar chart to the left of the map, which also serves as a legend for the maps coloring.</p>
              <p>
                Nationally drug overdose related deaths have increased dramatically over time, and the majority of those
                overdose deaths (more than six out of ten) involve an opioid. We can clearly see this increasing trend
                by using the player controls at the upper right, which can be used to quickly switch
                between years, or step through each year sequentially. 91 Americans die each day from an opioid
                overdose.</p>

            </ReadMore>
          </Col>
          <Col xs={24} md={18} xl={19}>
            <Row gutter={5} type="flex">
              <Col xs={{span: 24, order: 2}} md={{span: 9, order: 1}}>
                <h2>County Totals by Overdose Rate : {this.state.year}</h2>
                <HeatBarChart
                  dimX="range"
                  dimY="count"
                  data={this.props.counts[this.state.year]}/>
              </Col>
              <Col xs={{span: 24, order: 1}} md={{span: 15, order: 2}}>
                <h2>Overdose Death Rates by County : {this.state.year}</h2>
                <div className="heat-wrapper">
                  <HeatMap
                    year={this.state.year}
                    dict={this.props.dict}
                    data={this.props.data}
                    onClick={this.props.actions.selectState}/>
                </div>
                <div className="slider-wrapper">
                  <Slider vertical
                          dots={true}
                          included={false}
                          marks={marks}
                          value={this.state.sliderYear}
                          step={1}
                          min={2000}
                          max={2015}
                          onChange={d => this.setState({sliderYear: d})}
                          onAfterChange={this.onAfterChange.bind(this)}/>
                </div>
              </Col>
            </Row>
            <Row>
              <h2 style={{margin: '15px 0 -10px'}}>Age Adjusted Overdose Rates Since 2000</h2>
              <LineChart
                dimG="group"
                dimX="year"
                dimY="overdoseRate"
                highlightX={+this.state.year}
                hover={true}
                data={this.props.timeline}/>
            </Row>
          </Col>
        </Row>
      </Card>
    );
  }
}

function mapStoreToProps(store, props) {
  return {
    loading: store.overdose.loading,
    timeline: store.overdose.timeline,
    data: store.overdose.data,
    dict: store.overdose.dict,
    counts: store.overdose.counts
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(mapActions, dispatch)
  }
}

export default connect(mapStoreToProps, mapDispatchToProps)(OverdoseCard);



// WEBPACK FOOTER //
// ./src/containers/OverdoseCard.js